<template>
  <el-pagination v-if="total > 0" layout="prev, pager, next" :current-page="pageNum" :page-size="pageSize"
    :total="total" @current-change="changeSize">
  </el-pagination>
</template>

<script>
export default {
  props: {
    pageNum: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 6,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    changeSize(e) {
      this.$emit("changeSize", e);
    },
  },
};
</script>

<style>
.el-pager li.active {
  background-color: #E2291E;
  color: #fff;
}

.el-pager li {
  font-size: 16px;
  width: 20px;
  min-width: 20px;
  padding: 0;
  margin: 0 10px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #2C2C2E;
  line-height: 19px;
  text-align: center;
  font-style: normal;
}

.el-pager li:hover {
  color: #E2291E;
}

.el-pager li.active:hover {
  color: #fff;
}

.el-pager li.btn-quicknext,
.el-pager li.btn-quickprev {
  line-height: 40px;
}

.el-pagination {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-pagination .btn-prev,
.el-pagination .btn-next {
  width: 40px;
  height: 40px;
}

.el-pagination .btn-prev:hover,
.el-pagination .btn-next:hover {
  color: #e13133;
}

.el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  font-size: 20px;
}

.el-pagination .btn-next,
.el-pagination .btn-prev {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/common/pagination.vue